import StandardButton from "../UI/buttons/StandardButton";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevron_black.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";
import { useAppDispatch } from "../../store/hooks";
import React, { useEffect, useState } from "react";
import labels from "../../utils/labels";
import { Spinner } from "../UI/Spinner";
import DragAndDropService from "../../service/dragAndDrop";
import { SendPlanToNexus } from "../../service/sendToNexus";

const SendToNexus = ({
  idScenario,
  check,
  forceSend = false,
  inEditMode,
}: {
  idScenario: number;
  check: boolean;
  forceSend?: boolean;
  inEditMode?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const [endpointResult, setEndpointResult] = useState<{
    hasCalled: boolean;
    success: boolean;
  }>({ hasCalled: false, success: false });
  const [callingBackend, setCallingBackend] = useState<boolean>(false);
  const [icon, setIcon] = useState<React.ReactNode>(
    inEditMode ? <ChevronIcon /> : undefined
  );

  const sendToNexus = async (force: boolean = false) => {
    setCallingBackend(true);
    let result = { hasCalled: false, success: false };
    if (inEditMode) {
      result = await SendPlanToNexus.saveCustomPlan(dispatch);
    } else {
      result = await SendPlanToNexus.sendOptimisedPlanToNexus({
        idScenario,
        force: true,
        forceSend,
        dispatch,
      });
    }

    setCallingBackend(false);
    setEndpointResult(result);
  };

  useEffect(() => {
    if (endpointResult.hasCalled && endpointResult.success)
      setIcon(<CheckIcon />);
    else if (callingBackend) setIcon(<Spinner height={18} width={18} />);
    else setIcon(<ChevronIcon />);
  }, [check, callingBackend, endpointResult]);

  const saveEditChanges = async () => {
    setIcon(<Spinner height={18} width={18} />);
    const response = await DragAndDropService.saveAndFinalizePlan(dispatch);
    if (response?.success)
      setIcon(<ChevronIcon />); //it now changes into a "Send to Nexus" button - should probably be seperated into two seperate components.
    else setIcon(undefined);
  };

  return (
    <StandardButton
      onClick={inEditMode ? saveEditChanges : () => sendToNexus()}
      variant="PRIMARY"
      iconRight={icon}
    >
      {inEditMode ? labels.saveChanges : labels.sendNexusData}
    </StandardButton>
  );
};

export default SendToNexus;
